'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var miniEnsureLogged = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var member, token;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            member = JSON.parse(decodeURIComponent(_jsCookie2.default.get(_util.MEMBER_NAME) || '{}'));


            console.log(member.id, 'member from cache');

            if (!(!member || !member.id)) {
              _context.next = 14;
              break;
            }

            console.log('in request /app/member ');
            _context.prev = 4;
            _context.next = 7;
            return (0, _request2.default)({
              url: '/app/member',
              _jumpReplace: true // 跳过兼容安卓代码
            });

          case 7:
            member = _context.sent;


            member = member.data;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context['catch'](4);

            console.log(_context.t0, 'await request member error');

          case 14:

            member && _jsCookie2.default.set(_util.MEMBER_NAME, member, { expires: 365 });

            console.log(member, 'loading member finish');

            token = _jsCookie2.default.get(_util.TOKEN_NAME);

            if (!(token && member && member.mobile)) {
              _context.next = 21;
              break;
            }

            return _context.abrupt('return', _promise2.default.resolve({
              alreadyLogged: true
            }));

          case 21:
            _jsCookie2.default.remove('_m_load_state');
            (0, _navigate.jumpTo)({ url: ENSURE_LOGGED_PAGE });
            return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
              var i = setInterval(function () {
                var token = _jsCookie2.default.get(_util.TOKEN_NAME);
                var error = _jsCookie2.default.get(_util.LOGGED_ERROR);
                var loadState = _jsCookie2.default.get('_m_load_state');
                if (token && loadState) {
                  clearInterval(i);
                  resolve({ logged: true });
                } else if (error) {
                  clearInterval(i);
                  _jsCookie2.default.remove(_util.LOGGED_ERROR);
                  reject({ message: error });
                }
              }, 300);
            }));

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 11]]);
  }));

  return function miniEnsureLogged() {
    return _ref.apply(this, arguments);
  };
}();

exports.ensureLogged = ensureLogged;
exports.setToken = setToken;
exports.getMember = getMember;

var _util = require('../lib/util');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _navigate = require('../navigate');

var _request = require('../request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENSURE_LOGGED_PAGE = '/pages-two/webview-ensure-logged/index';

function ensureLogged(v) {
  var vm = v || (0, _util.getVue)();
  return new _promise2.default(function (resolve) {
    _util.adapter.invoke(resolve);
  }).then(function () {
    if (_util.adapter.env === 'miniprogram') {
      return miniEnsureLogged();
    } else {
      if (!vm || !vm.$ensureLogged) {
        console.error('sdk: $ensureLogged is not defined!');
        return _promise2.default.reject();
      }
      return vm.$ensureLogged();
    }
  });
}

function setToken() {
  _util.adapter.invoke(function () {
    if (_util.adapter.env === 'miniprogram') {
      var auth = _util.query[_util.TOKEN_NAME] ? _util.query[_util.TOKEN_NAME] : '';
      var beastId = _util.query[_util.BEAST_ID] ? _util.query[_util.BEAST_ID] : '';
      var member = JSON.parse(decodeURIComponent(_jsCookie2.default.get(_util.MEMBER_NAME) || '{}'));
      console.log(member, 'set token');
      var logError = _util.query[_util.LOGGED_ERROR] ? _util.query[_util.LOGGED_ERROR] : '';
      _jsCookie2.default.set('_m_load_state', true, { expires: 365 });
      if (auth) {
        _jsCookie2.default.set(_util.TOKEN_NAME, auth, { expires: 365 });
        _jsCookie2.default.set(_util.MEMBER_NAME, member, { expires: 365 });
        _jsCookie2.default.set(_util.BEAST_ID, beastId, { expires: 365 });
      } else {
        _jsCookie2.default.remove(_util.TOKEN_NAME);
        _jsCookie2.default.remove(_util.MEMBER_NAME);
        // Cookie.remove(BEAST_ID)
      }
      if (logError) {
        _jsCookie2.default.set(_util.LOGGED_ERROR, logError, { expires: 365 });
      }
    }
  });
}

function getMember() {
  console.log('getmember from cache');
  var member = void 0;
  try {
    member = JSON.parse(decodeURIComponent(_jsCookie2.default.get(_util.MEMBER_NAME) || '{}'));
  } catch (e) {
    member = {};
  }
  return _promise2.default.resolve(member);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/sdk/lib/login/index.js
// module id = 974
// module chunks = 0